import { Component } from '@angular/core'
import { $app } from '@app/app.service'

@Component({
   selector: 'page-app-basic',
   template: '',
})
export class AppBasicPage {
   console: boolean = $app.core.modeDevel
   logPrefix: string = '@page - ' + this.constructor.name

   $app = $app //for use in template

   modePage: string = ''
}

